// extracted by mini-css-extract-plugin
module.exports = {"loggingButton":"styles_loggingButton__1P9mA","passwordInput":"styles_passwordInput__2lkrA","emailInput":"styles_emailInput__21Qfk"};